export const getReportsRoute = (id) => id ? `/reports/${id}` : `/reports`;

export const getReportGradingRoute = (id, questionNumber) => `${getReportsRoute(id)}/grading/${questionNumber}`;